
export default class VersionDict {

    public platform?: string = undefined;
    public version?: string = undefined;

    public assign(response: any): VersionDict {
        if (response) {
            for (const key in response) {
                if (response.hasOwnProperty(key) && this.hasOwnProperty(key)) {
                    (this as any)[key] = response[key];
                }
            }
        }

        return this;
    }

}
